<template>
	<IconBase icon-name="export">
		<path d="M 9,12 H 15 l -3,4 z" class="blueFill blueStroke" />
		<path d="M 18,19 H 6" class="blueStroke" />
		<path d="M 12,4 V 11" class="blueStroke" />
	</IconBase>
</template>

<script>
import IconBase from './IconBase';
export default {
	components: {
		IconBase
	}
};
</script>
